export interface CostEstimate {
  advancedSecurityDailyCents: number;
  advancedSecurityMonthlyCents: number;
  biConnectorMaxDailyCents: number;
  biConnectorMaxMonthlyCents: number;
  biConnectorSustainedDailyCents: number;
  dailyEstimateCents: number;
  enterpriseAuditingDailyCents: number;
  enterpriseAuditingMonthlyCents: number;
  monthlyEstimateCents: number;
  monthlyFeesEstimateCents: number;
  snapshotBackupMonthlyCentsPerGB: number;
}

export enum PartnerType {
  AWS = 'AWS',
  GCP = 'GCP',
}

export enum PartnerLinkStatusCode {
  AVAILABLE = 'AVAILABLE',
  PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
  LINK_SUCCESS = 'LINK_SUCCESS',
  CUSTOMER_LINKED = 'CUSTOMER_LINKED',
  FAILED_PAYMENTS = 'FAILED_PAYMENTS',
  IS_LINKED_ORG = 'IS_LINKED_ORG',
  IS_PAYING_ORG = 'IS_PAYING_ORG',
  NOT_ATLAS = 'NOT_ATLAS',
  ORGANIZATION_LINKED = 'ORGANIZATION_LINKED',
  SUBSCRIPTION_INVALID_STATUS = 'SUBSCRIPTION_INVALID_STATUS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNAVAILABLE = 'UNAVAILABLE',
}

export interface OrganizationLinkStatuses {
  linkable: boolean;
  linkStatusCode: PartnerLinkStatusCode;
  linkStatusDescription: string;
  userRoles: Array<string>;
  organization: {
    id: string;
    name: string;
  };
}
export interface PartnerCustomerLinkOrgStatus {
  partnerType: PartnerType;
  organizationLinkStatuses: Array<OrganizationLinkStatuses>;
}

export interface PartnerCustomerLinkOrgResult {
  success: boolean;
  linkStatusCode: PartnerLinkStatusCode;
  linkStatusDescription: string;
  partnerType: PartnerType;
  organizationId: string;
}

export interface PartnerSubscriptionStatusResult {
  success: boolean;
  subscriptionStatusCode: string;
  subscriptionStatusDescription: string;
  partnerType: string;
  organizationId: string;
}

export interface MarketplaceRegistrationData {
  partnerType: PartnerType;
}

export interface MarketplaceRegistrationCookie {
  partnerType: PartnerType;
}

export enum PartnerSubscriptionStatus {
  SUCCESS = 'success',
  PENDING = 'pending',
  FAILURE = 'failure',
  NOT_LINKING = 'not_linking',
}

export enum PartnerSubscriptionStatusCode {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
  FAILED = 'FAILED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
  NOT_FOUND = 'NOT_FOUND',
}

export enum PaymentMethodStatus {
  ACTIVE = 'ACTIVE',
  PENDING_ACTIVATION = 'PENDING_ACTIVATION',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}
